module.exports = __webpack_public_path__ + "media/svg-new/ranking-a4bda898.svg";